import React, { useEffect, useState } from "react";
import { Tooltip } from "primereact/tooltip";
import { Ripple } from "primereact/ripple";

const BackToTop: React.FC = () => {
    const [isVisible, setIsVisible] = useState<boolean>(false);
    const [scrollProgress, setScrollProgress] = useState<number>(0);

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.scrollY;
            const windowHeight = document.documentElement.scrollHeight - window.innerHeight;
            const progress = (scrollTop / windowHeight) * 100;

            setScrollProgress(progress);
            setIsVisible(scrollTop > 80);
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <React.Fragment>
            <Tooltip target=".back_to_top" />
            <div
                className={`back_to_top p-ripple ${isVisible ? 'visible' : ''}`}
                onClick={scrollToTop}
                data-pr-tooltip="Back to top"
                data-pr-position="left"
            >
                <svg className="progress_ring" width="50" height="50">
                    <circle
                        className="progress_ring__circle"
                        stroke="#FFF"
                        strokeWidth="4"
                        fill="transparent"
                        r="21"
                        cx="25"
                        cy="25"
                    />
                    <circle
                        className="progress-ring__progress"
                        stroke="#F37C47"
                        strokeWidth="4"
                        fill="transparent"
                        r="21"
                        cx="25"
                        cy="25"
                        strokeDasharray="130"
                        strokeDashoffset={130 - (scrollProgress / 100) * 130}
                        strokeLinecap="round"
                    />
                </svg>
                <svg
                    className="up_arrow_icon"
                    width="23"
                    height="23"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#F37C47"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}
                >
                    <path d="M12 19V6" />
                    <path d="M5 12l7-7 7 7" />
                </svg>
                <Ripple />
            </div>
        </React.Fragment>
    )
}

export default BackToTop;